import { useRef } from 'react';

import { useMutation, useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { UI_STATUS_TYPE } from '@/constants';
import { uiStatusQuery, updateUiStatusMutation } from '@/query';
import { APP_ROUTES } from '@/routes';
import { TutorialMappingTab } from '@/types';

import { useLatest } from './useLatest';
import { useMappingModalContext } from './useMappingModalContext';

type Options = {
  hasSeenTutorial: boolean;
  markAsSeen: () => void;
  stopTutorial: () => void;
  setMoreActionsTab: (tab: TutorialMappingTab | null) => void;
  setBulkSelectTab: (tab: TutorialMappingTab | null) => void;
};

export const useTutorialFinish = ({
  hasSeenTutorial,
  markAsSeen,
  stopTutorial,
  setMoreActionsTab,
  setBulkSelectTab,
}: Options) => {
  const navigateRef = useLatest(useNavigate());
  const { showModal } = useMappingModalContext();
  const { data: uiStatusData } = useQuery(uiStatusQuery());
  const { mutate: sendUiStatusUpdate } = useMutation(updateUiStatusMutation());
  const hasPostedRef = useRef(false);

  return (wasCompleted: boolean) => {
    const isAlreadyPassed = hasSeenTutorial || uiStatusData?.result?.isPassed === true;

    if (!hasPostedRef.current && !isAlreadyPassed) {
      hasPostedRef.current = true;
      sendUiStatusUpdate({ uiStatusType: UI_STATUS_TYPE.DataManagementTutorial, isPassed: true });
    }

    setMoreActionsTab(null);
    setBulkSelectTab(null);
    markAsSeen();
    stopTutorial();
    navigateRef.current(APP_ROUTES.aires);

    if (wasCompleted) {
      showModal();
    }
  };
};
